import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { getChats } from 'redux-store/thunk/chat.thunk'
import { setChat, updateDeletedChat } from 'redux-store/redux/slices/chat.slice'
import useLiveChatSocketNameSpace from 'socket-resources/hooks/useChatNameSpace'
import { CHAT_STATUS } from 'utils/constants/index'
import { getAuthToken } from 'utils/common-services/cookie.service'

const ChatContent = ({ bottomRef }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const isLoggedIn = useSelector((state) => state.auth?.isLoggedIn)
  const userInfo = useSelector((state) => state.auth?.userInfo || state.auth?.user)
  const { chat, selectedRoomId, selectedChatGroupId } = useSelector(
    (state) => state.chat
  )
  const { listenLiveChatsUpdateEvent, listenChatDeletedEvent } = useLiveChatSocketNameSpace()

  const handleLiveChatsData = (e) => {
    console.log('chat listener added', e)
    if (e?.data) {
      dispatch(setChat(e.data))
    }
  }

  const shouldShowChat = (chatItem) => {
    const isNotSameChatGroup =
      chatItem?.groupId?.toString() !== selectedChatGroupId?.toString()
    if (isNotSameChatGroup) return false
    return true
  }

  useEffect(() => {
    if (isLoggedIn && selectedRoomId && selectedChatGroupId) {
      dispatch(
        getChats({
          limit: 20,
          startDate: moment().subtract(7, 'd').format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
          languageId: selectedRoomId,
          groupId: selectedChatGroupId
        })
      )
    }
  }, [isLoggedIn, selectedRoomId, selectedChatGroupId, dispatch])

  useEffect(() => {
    const cleanUpListener = listenLiveChatsUpdateEvent(handleLiveChatsData)
    const cleanUpChatDeletedListener = listenChatDeletedEvent((e) => {
      dispatch(updateDeletedChat(e?.data))
    })
    return () => {
      cleanUpListener()
      cleanUpChatDeletedListener()
    }
  }, [dispatch, listenLiveChatsUpdateEvent, listenChatDeletedEvent])

  useEffect(() => {
    if (bottomRef?.current && chat?.rows?.length > 0) {
      const scrollContainer = bottomRef.current.closest('.chat-content-scroll')
      if (scrollContainer) {
        scrollContainer.scrollTo({
          top: scrollContainer.scrollHeight,
          behavior: 'smooth'
        })
      }
    }
  }, [chat, bottomRef])

  return (
    <div className='chat-content-scroll'>
      <div className='chat-content-wrap'>
        {chat?.rows?.filter(shouldShowChat)?.map((userChat, idx) => {
          return (
            <section key={userChat?.id || idx || uuidv4()}>
              <div className='chat-bubble'>
                <div className='chat-text-content d-flex gap-3'>
                  <div>
                    <div
                      style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        backgroundColor: '#FFC692',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#220A06',
                        fontWeight: 600,
                        fontSize: '16px',
                        flexShrink: 0
                      }}
                    >
                      {(userChat?.user?.firstName?.[0] || userChat?.user?.userName?.[0] || 'U').toUpperCase()}
                    </div>
                  </div>

                  <div className='message-box'>
                    <div className='heading'>
                      {userChat?.user?.firstName || userChat?.user?.userName || `User${userChat.userId}`}
                    </div>

                    <div className='content'>
                      {userChat.status === CHAT_STATUS.DELETED
                        ? (
                          <span style={{ fontStyle: 'italic' }}>Deleted message</span>
                        )
                        : (
                          <span>{userChat?.message}</span>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )
        })}
        <div id='empty-chat' className='empty-chat' ref={bottomRef} />
      </div>
    </div>
  )
}

export default ChatContent
